/**
 * Created by Kieran on 06/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let ProfileApi = {
  /**
   * @param model
   * @returns {AxiosPromise}
   */
  getProfile(profileUrl) {
    return axios.get(config.apiUrl + 'profile/' + profileUrl)
  },
  /**
   *
   * @param image
   * @returns {AxiosPromise}
   */
  changeProfilePicture(image) {
    return axios.post(config.apiUrl + 'upload/profile-picture/', {
      image: image
    })
  },
  /**
   *
   * @param imageId
   * @returns {AxiosPromise}
   */
  deleteImage(imageId) {
    return axios.delete(config.apiUrl + 'profile/image/' + imageId);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  follow(model) {
    return axios.post(config.apiUrl + 'followers/follow/', model);
  },
  /**
   *
   * @param params
   * @returns {AxiosPromise}
   */
  getFollowers(params) {
    return axios.get(config.apiUrl + 'followers/' + params.user_id, {
      params: {
        type: params.type,
        page: params.page,
        page_size: params.page_size,
      }
    })
  },
  /**
   *
   * @param bio
   * @returns {AxiosPromise}
   */
  saveBio(bio) {
    return axios.put(config.apiUrl + 'profile/bio', {
      bio: bio
    });
  },
  /**
   *
   * @returns {string}
   */
  galleryUploadURL() {
    return config.apiUrl + 'profile/image/upload/';
  },

  deleteProfilePicture() {
    return axios.delete(config.apiUrl + 'upload/profile-picture/remove/');
  },

  deleteCoverPhoto() {
    return axios.delete(config.apiUrl + 'upload/user/cover/remove/');
  }
};

export default ProfileApi



// WEBPACK FOOTER //
// ./src/api/Profile/index.js